const response = [
  {
    designId: 48096012,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/Aq3ajtCqURQ/listing_large-p1-en-GB?v=1620778123',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/7Hiz-ikG-uc?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Greek Island Church',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48096012,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/Aq3ajtCqURQ/listing_large-p1-en-GB?v=1620778123',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/7Hiz-ikG-uc?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Greek Island Church',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48096012,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/Aq3ajtCqURQ/listing_large-p1-en-GB?v=1620778123',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/7Hiz-ikG-uc?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Greek Island Church',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48096016,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/q0-bjAF5OS8/listing_large-p1-en-GB?v=1620778039',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/n6M99QLNYfM?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Aerial Beach View',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48095390,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/zoTb8uHe1x0/listing_large-p1-en-GB?v=1620777376',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/od1FY6KC3Jk?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Lush Green Palms',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48098669,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/zRaf6hnCvv0/listing_large-p1-en-GB?v=1620776793',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/ExCcZtGoS5E?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Leaf Pattern',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48097940,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/Sqe9_FacEoI/listing_large-p1-en-GB?v=1620778439',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/g1M9d6ONk1c?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Abstract Aesthetic Shapes 1',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48100726,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/RfzeHI2W6Tw/listing_large-p1-en-GB?v=1620776907',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/QjPzJBkoFkc?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Old Greek Church',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48096623,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/ArVs_BMzRaY/listing_large-p1-en-GB?v=1620778628',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/9-PAGSPICBo?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Contemporary Floral Pattern',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48095417,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/LfCdHHie4OI/listing_large-p1-en-GB?v=1620777240',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2750/lRQTRa0q1RE?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Minimal Ficus',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2750,
  },
  {
    designId: 48097917,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/6YbVWJynX-I/listing_large-p1-en-GB?v=1620779236',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2754/-bNJOMyyUYQ?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Fishing Boat',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2754,
  },
  {
    designId: 48097341,
    thumbnail: 'https://sl-public.s3-eu-west-1.amazonaws.com/do/mFcLPMYSi10/listing_large-p1-en-GB?v=1620776692',
    color: [],
    formatsCount: '1 format',
    isFavourite: false,
    url: 'https://www.optimalprint.co.uk/product/category/2754/r53loPp636I?x=1&q=1&spot=1&trim=1&substrate=1',
    productTypeId: 136,
    paperFormatId: 0,
    name: 'Mallorca Coast',
    spotFinishId: 1,
    spotFinishes: [1],
    trimId: 1,
    trims: [1],
    productId: 10602,
    availableUpsellOptions: [],
    extraParams: {
      notebookPattern: null,
      posterEditorFunnel: null,
      productDesignerEditorFunnel: null,
      isPublicNonPersonalized: null,
    },
    availableExtraParams: [
      {
        key: 'productDesignerEditorFunnel',
        values: [
          {
            value: 'api-editor',
            title: 'Api editor flow',
            previewUrl: null,
          },
        ],
      },
    ],
    categoryId: 2754,
  },
];

export default response;
